var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGradCap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.456l8.115 3.456 7.101-3.024v7.344h1.015V3.456L8.115 0 0 3.456z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.043 5.235v3.837l5.072 2.16 5.072-2.16V5.235l-5.072 2.16-5.072-2.16z",
    fill: "current"
  })));
}
export default SvgGradCap;